import { useIntl } from "react-intl"
import './ActivateBankId.scss'
import { Elements, TextInput } from '@tfo/common'
import $http from "../../../utils/$http"
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { BankId } from '@tfo/ppl'
import React from 'react'

const { Paragraph } = Elements

type NationalIdResponse = {
    nationalId: string
}

type ActivateBankIdProps = {
    nationalId: string
    parseNationalId: (string) => void
}

const ActivateBankId: React.FC<ActivateBankIdProps> = ({ nationalId, parseNationalId }) => {
    const intl = useIntl()

    const activateBankId = async (encryptedCompletionData: string) => {
        const response = await $http.post<NationalIdResponse>('/authenticate/bankId/activate',
            {
                encryptedCompletionData: encryptedCompletionData
            })
        if (response.nationalId === null || response.nationalId === undefined) {
            return
        }
        parseNationalId(response.nationalId)
    }

    const qrCodeBankId = async (protectedQrState: string): Promise<{ qrCode: string }> => {
        return await $http.post<{ qrCode: string }>('/authenticate/bankid/qrcode', {
            protectedQrState: protectedQrState
        })
    }

    const authBankId = async (onSameDevice: boolean): Promise<{
        protectedOrderRef: string
        protectedQrStartState: string
        qrCode: string
        launchUrl: string
    }> => {
        return await $http.post<{
            protectedOrderRef: string
            protectedQrStartState: string
            qrCode: string
            launchUrl: string
        }>('/authenticate/bankid/auth', {
            isSameDevice: onSameDevice
        })
    }

    const collectBankId = async (protectedOrderRef, attempt): Promise<{
        completionData?: string
        statusMessage?: string
        hintCode?: string
    }> => {
        return await $http.post<{
            completionData?: string
            statusMessage?: string
            hintCode?: string
        }>
            ('/authenticate/bankid/collect', {
                protectedOrderRef,
                attempt
            });
    }

    const cancelBankIdSession = async (orderRef: string) => {
        await $http.post<{
            protectedOrderRef: string
            protectedQrStartState: string
            qrCode: string
        }>('/authenticate/bankid/cancel', {
            protectedOrderRef: orderRef
        })
    }



    return (
        <div className="bankid-container">
            {nationalId.length < 1 ?
                <>
                    <div className="header">{intl.formatMessage({ id: 'common.activate.bankId' })}</div>
                    <BankId
                        authenticateEncryptedData={activateBankId}
                        startAuthOnDisplay={true}
                        authBankId={authBankId}
                        cancelBankIdSession={cancelBankIdSession}
                        collectBankId={collectBankId}
                        qrCodeBankId={qrCodeBankId}
                    />
                </>
                :
                <div className="bankid-success-wrapper">
                    <div>
                        <TextInput
                            style={{ width: '37rem' }}
                            value={nationalId}
                            disabled
                        />
                    </div>
                    <CheckCircleIcon style={{ color: '#009B48' }} fontSize="large" />
                    <Paragraph className="help-paragraph" small>{intl.formatMessage({ id: 'common.activated.bankId.success' })}</Paragraph>
                </div>
            }
        </div>
    )
}

export default ActivateBankId